import { qportalApi } from './qportal-api';
// Deliberately separate from the consuming BC feed and requeue APIs.
export const getBusinessCentralStaging = (params, signal) => qportalApi.get('admin/business-central/staging', { params, signal });
